<!-- @veltra/icons generated sha256:07bfdd500e7fc1db gen:8 source:src/svg/normal/file-add.svg -->
<script setup lang="ts">
defineOptions({ name: 'FileAdd' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3 2c0-.556.444-1 1-1h4.293a1 1 0 0 1 .336.058c.1.017.2.064.285.148l3.71 3.71v.002l.083.082a1 1 0 0 1 .293.707v2.28a.5.5 0 0 1-.496.497.495.495 0 0 1-.504-.49V6H9.02C8.466 6 8 5.533 8 4.98V2H4v11h4.037a.501.501 0 0 1 0 1H4c-.556 0-1-.444-1-1zm6.495 3h1.798L9 2.707v1.798c0 .276.22.495.495.495M12 13v1.49c0 .277.228.51.496.51a.51.51 0 0 0 .504-.51V13h1.49a.51.51 0 0 0 .51-.496.51.51 0 0 0-.51-.504H13v-1.49a.51.51 0 0 0-.496-.51.51.51 0 0 0-.504.51V12h-1.49a.51.51 0 0 0-.51.496c0 .276.234.504.51.504z"
    />
  </svg>
</template>
